import { api } from "./api";

import { postFetch } from "./request";

const commonModel = {
  // 初始化接口
  init: async (Data) => {
    const success = await postFetch(api.init, Data);
    return success;
  },
  // 获取服务器时间
  time: async (Data) => {
    const success = await postFetch(api.time, Data);
    return success;
  },
  // 发送短信
  info: async (Data) => {
    const success = await postFetch(api.info, Data);
    return success;
  },
  // 获取文章列表
  articles: async (Data) => {
    const success = await postFetch(api.articles, Data);
    return success;
  },
  articles2: async (Data) => {
    const success = await postFetch(api.articles2, Data);
    return success;
  },
  // 获取文章详情
  details: async (Data) => {
    const success = await postFetch(api.details, Data);
    return success;
  },
  // 获取栏目列表
  columns: async (Data) => {
    const success = await postFetch(api.columns, Data);
    return success;
  },
  // 获取栏目扩展字段
  additi: async (Data) => {
    const success = await postFetch(api.additi, Data);
    return success;
  },
  // 立即预约
  reserve: async (Data) => {
    const success = await postFetch(api.reserve, Data);
    return success;
  },
  // 获取玩家预约邀请码
  getInviteCode: async (Data) => {
    const success = await postFetch(api.getInviteCode, Data);
    return success;
  },
  // 获取预约礼包
  giftLog: async (Data) => {
    const success = await postFetch(api.giftLog, Data);
    return success;
  },
  //获取预约里程碑数据
  milestone: async (Data) => {
    const success = await postFetch(api.milestone, Data);
    return success;
  },
  //根据ip获取区号
  getAreaCode: async (Data) => {
    const success = await postFetch(api.areaCode, Data);
    return success;
  },
  // 获取活动信息
  getActivityInfo: async (Data) => {
    const success = await postFetch(api.activityInfo, Data);
    return success;
  },
  // 预创盟
  // 预创盟用户信息
  getUserinfo: async (Data) => {
    const success = await postFetch(api.getUserinfo, Data);
    return success;
  },
  // 创建联盟
  alliance: async (Data) => {
    const success = await postFetch(api.alliance, Data);
    return success;
  },
  // 联盟列表
  allianceList: async (Data) => {
    const success = await postFetch(api.allianceList, Data);
    return success;
  },
  // 加入联盟
  joinAlliance: async (Data) => {
    const success = await postFetch(api.joinAlliance, Data);
    return success;
  },
  // 获取任务积分
  point: async (Data) => {
    const success = await postFetch(api.point, Data);
    return success;
  },
  // 获取同盟邀请码
  allianceInviteCode: async (Data) => {
    const success = await postFetch(api.allianceInviteCode, Data);
    return success;
  },
  // 同盟奖励
  allianceGift: async (Data) => {
    const success = await postFetch(api.allianceGift, Data);
    return success;
  },
  // 我的同盟
  myAlliance: async (Data) => {
    const success = await postFetch(api.myAlliance, Data);
    return success;
  },
  /**
  新增抽奖接口
   */
  // 获取抽奖任务
  taskList: async (Data) => {
    const success = await postFetch(api.taskList, Data);
    return success;
  },
  // 获取抽奖次数
  drawTask: async (Data) => {
    const success = await postFetch(api.drawTask, Data);
    return success;
  },
  // 玩家可用抽奖次数
  getDrawNum: async (Data) => {
    const success = await postFetch(api.getDrawNum, Data);
    return success;
  },
  // 抽奖
  luckDrawDo: async (Data) => {
    const success = await postFetch(api.luckDrawDo, Data);
    return success;
  },
  // 抽奖日志
  luckDrawGetLog: async (Data) => {
    const success = await postFetch(api.luckDrawGetLog, Data);
    return success;
  },
  // 日本冒险岛新增接口
  // 获取用户星辉OPENID预约
  getUserOpenidReserve: async (Data) => {
    const success = await postFetch(api.getUserOpenidReserve, Data);
    return success;
  },
  // 获取邀请奖励礼包
  getInviteReward: async (Data) => {
    const success = await postFetch(api.getInviteReward, Data);
    return success;
  },
  // 单手杀小游戏初始化
  miniGameInit: async (Data) => {
    const success = await postFetch(api.miniGameInit, Data);
    return success;
  },
  // 击杀数据
  miniGameSaveData: async (Data) => {
    const success = await postFetch(api.miniGameSaveData, Data);
    return success;
  },
  // 领取击杀礼包
  miniGameGetGift: async (Data) => {
    const success = await postFetch(api.miniGameGetGift, Data);
    return success;
  },
  // 寻宝页
  // 寻宝活动-用户数据初始化
  treasureUserInit: async (Data) => {
    const success = await postFetch(api.treasureUserInit, Data);
    return success;
  },
  // 口令兑换
  doTreasure: async (Data) => {
    const success = await postFetch(api.doTreasure, Data);
    return success;
  },
  // 阶段礼包列表
  treasureGiftList: async (Data) => {
    const success = await postFetch(api.treasureGiftList, Data);
    return success;
  },
  // 阶段礼包列表
  treasureColumns: async (Data) => {
    const success = await postFetch(api.treasureColumns, Data);
    return success;
  },
};
export default commonModel;
